/* Fades each section into place the first time it enters the viewport. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const sections = document.querySelectorAll('main .shopify-section, footer .shopify-section');
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  for (const section of sections) {
    // The signup popup lives in the footer group but opens as a modal; never fade its wrapper.
    if (section.querySelector('.vd-signup')) continue;
    const rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.9) continue;
    section.classList.add('vd-reveal');
    observer.observe(section);
  }
})();
